import { formatDateTime } from "../../lib/api";

export const INQ_STATUS = {
  new: { label: "New", cls: "border-[var(--gold)] text-gold" },
  assigned: { label: "Assigned", cls: "border-sky-400/50 text-sky-300" },
  contacted: { label: "Contacted", cls: "border-indigo-300/50 text-indigo-200" },
  follow_up: { label: "Follow-Up Required", cls: "border-orange-400/50 text-orange-300" },
  negotiation: { label: "Negotiation", cls: "border-fuchsia-300/50 text-fuchsia-200" },
  completed: { label: "Completed", cls: "border-emerald-400/50 text-emerald-300" },
  closed: { label: "Closed", cls: "border-slate-500/50 text-slate-400" },
};

export const isOpen = (i) => !["completed", "closed"].includes(i.status);
export const followState = (i) => {
  if (!i.follow_up_at || !isOpen(i)) return null;
  return new Date(i.follow_up_at) <= new Date() ? "overdue" : "upcoming";
};

export const Pill = ({ cls, children, testid }) => (
  <span className={`inline-flex items-center gap-1 font-mono text-[0.62rem] uppercase tracking-wide px-2 py-1 border whitespace-nowrap ${cls}`} data-testid={testid}>{children}</span>
);

export const StatusPill = ({ status }) => {
  const s = INQ_STATUS[status] || INQ_STATUS.new;
  return <Pill cls={s.cls} testid="inquiry-status-pill">{s.label}</Pill>;
};

export const AssigneePill = ({ item }) =>
  item.assigned_name ? <Pill cls="border-white/20 text-slate-200" testid="inquiry-assignee-pill">{item.assigned_name}</Pill>
    : <Pill cls="border-rose-400/60 text-rose-300 bg-rose-400/10" testid="inquiry-unassigned-pill">Unassigned</Pill>;

export const FollowPill = ({ item }) => {
  const st = followState(item);
  if (!st) return null;
  return (
    <Pill cls={st === "overdue" ? "border-rose-500 text-white bg-rose-600/80" : "border-amber-400/60 text-amber-200"} testid={`followup-${st}-pill`}>
      {st === "overdue" ? "Overdue" : "Follow-up"} · {formatDateTime(item.follow_up_at)}
    </Pill>
  );
};

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  const off = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - off).toISOString().slice(0, 16);
};
